import { useSelector } from "react-redux";

const HomeMention = () => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const notice = [
		reduxChannel?.greetings1 ?? null,
		reduxChannel?.greetings2 ?? null,
		reduxChannel?.greetings3 ?? null,
		reduxChannel?.greetings4 ?? null,
	];
	return (
		<div
			className={`home-each`}
			style={{
				// backgroundColor: "#eef6ff"
				backgroundColor: "#e5f0ff",
			}}
		>
			<div className={`max-width-apply`}>
				<h3 className={`each-title search-info-title`}>
					{reduxChannel?.nickname ?? "채널명"}의 한마디
					{/*궁금한 성분이나 효능을 검색해 검증된 제품을 확인하세요.*/}
				</h3>
				<div className={`each-content-div`}>
					{notice.map((text, idx) => {
						if (text)
							return (
								<div className={`notice-content`} key={`notice-mention-${idx}`}>
									{/*<div className={`notice-number`}>*/}
									{/*    /!*<p>0{idx + 1}</p>*!/*/}
									{/*</div>*/}
									<div className={`notice-text-div`}>
										<p>{text}</p>
									</div>
								</div>
							);
					})}
				</div>
			</div>
		</div>
	);
};
export default HomeMention;
